export enum SortTypes {
  NAME = 'Name',
  SERVICES = 'Services',
}
